import zIndex from "@mui/material/styles/zIndex";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import { Dialog } from "primereact/dialog"
import { ScrollPanel } from "primereact/scrollpanel"
import { useState } from "react";
import Lightbox from "react-image-lightbox";

type Props = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    item: ItemClasseAuditoria | null;
    style?: React.CSSProperties | undefined;
}

export default function ModalComentarioAuditoria(props: Props) {

    const [photoOpen, setPhotoOpen] = useState<boolean>(false);
    const [urlOpened, setUrlOpened] = useState<string>('');

    return (
        <>
            {photoOpen && (
                <Lightbox
                    mainSrc={urlOpened}
                    onCloseRequest={() => setPhotoOpen(false)}
                    reactModalStyle={{ overlay: { zIndex: 9999 } }}
                />
            )}
            <Dialog header="Comentários" visible={props.visible} baseZIndex={500} style={props.style ? props.style : { width: '50vw' }} onHide={() => props.setVisible(false)}>
                <div>
                    <ScrollPanel style={{ width: '100%', height: '400px' }}>
                        <div style={{ display: "flex", flexDirection: "column", rowGap: 10, columnGap: 10 }}>
                            {props.item && props.item.comentariosAuditoria && props.item.comentariosAuditoria.map((comentario, index) => {
                                return (
                                    <div key={index} style={{ borderBottom: "1px solid #d9d9d9" }}>
                                        <div style={{ display: "flex" }}>

                                            {comentario.imagens.map((imagem, index) => {
                                                return (
                                                    <div key={index} style={{ display: 'flex', marginTop: 8, overflow: 'auto' }}>
                                                        <div key={`img${index}`} style={{ justifyContent: 'center', borderWidth: 1, borderColor: '#dadada', borderStyle: 'solid', marginLeft: 5, display: 'grid' }}>
                                                            <a className='p-lightbox-image-target' style={{ marginLeft: 'auto', cursor: 'pointer', marginRight: 'auto', width: 128, textAlign: 'center' }} onClick={() => {
                                                                setTimeout(() => {
                                                                    setPhotoOpen(true)
                                                                    setUrlOpened(imagem.url)

                                                                }, 100)
                                                            }}>
                                                                <img style={{ maxHeight: 128, maxWidth: 128 }} src={imagem.url} title={imagem.nome} />
                                                            </a>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div style={{ marginTop: 20 }}>
                                            <p style={{ width: '100%' }} >
                                                {comentario.comentario}
                                            </p>
                                        </div>
                                    </div>

                                )
                            })}
                        </div>

                    </ScrollPanel>


                </div>

            </Dialog>
        </>
    )
}